// @flow

import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';
import type { Action } from 'esm-web-pro/components/layout/sidePanel/Actions';
import styled, { css, keyframes } from 'styled-components';
import { Box, Button } from 'grommet';

type Props = {
    action: Action,
    main: boolean,
    iconPadding: string,
}

const StyledButton = styled(Button)`
    width: ${(props) => props.width || '44px'};
    padding: ${(props) => props.iconPadding};
    margin-top: ${(props) => props.marginVertical || '0px'};
    margin-bottom: ${(props) => props.marginVertical || '0px'};
    border-radius: ${(props) => props.radius || '50%'};
    background-color: ${(props) => props.color || '#848890'};
    box-shadow: none;
    opacity: ${(props) => props.opacity};
    cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')}
`;

const StyledBox = styled(Box)`
    width: ${(props) => props.width || '50px'};
    align-self: flex-start;
    text-align: center;
    box-shadow: none;
    margin: ${(props) => (props.main ? '0px;' : '0px 12px;')}
    
    ${(props) => (!props.main && props.loading === 'true') && css`
      animation: ${keyframes`
          0% { opacity: 1; }
          30% { opacity: 0.6; }
          40% { opacity: 1; }
      `} 1s ease-in-out infinite;
    `}
`;

const ActionComponent = (props: Props) => {
    const { action, main, iconPadding } = props;

    return (
        <React.Fragment key={action.key || action.title || action.tooltip}>
            <StyledBox
                direction="column"
                width={action.width || { min: '50px' }}
                align="center"
                onClick={!action.disabled ? action.callback : undefined}
                flex={{ shrink: 0 }}
                main={main}
                loading={action.loading?.toString()}
            >
                <StyledButton
                    id={action.id || null}
                    icon={action.icon}
                    data-tip={action.tooltip}
                    data-for={action.tooltipKey || action.key}
                    color={action.disabled && main ? 'transparent' : action.color}
                    width={action.size}
                    iconPadding={iconPadding}
                    marginVertical={action.marginVertical}
                    radius={action.radius}
                    opacity={action.disabled ? '0.5' : '1'}
                    // disabled={action.disabled}
                />
                {/* {action.title && ( */}
                {/*    <Box justify="center" pad={{ top: '6px' }}> */}
                {/*        <Anchor */}
                {/*            size="xsmall" */}
                {/*            color="grey" */}
                {/*            onClick={e => handleClick(e, action)} */}
                {/*            textDecoration="none" */}
                {/*        > */}
                {/*            {action.title} */}
                {/*        </Anchor> */}
                {/*    </Box> */}
                {/* )} */}
                {(!action.tooltipKey && action.tooltip) && (
                    <ReactTooltip
                        id={action.key}
                        effect="solid"
                        place="top"
                        className="react-tooltip"
                    >
                        <LabelText>{action.tooltip}</LabelText>
                    </ReactTooltip>
                )}
            </StyledBox>
        </React.Fragment>
    );
};

export default ActionComponent;
